import React, { useRef, useState } from "react";

import { ReportLayoutDropdown } from "./ReportPageDropdown";
import styles from "./ReportPageSelect.module.scss";
import { LayoutIcon } from "./assets";
import { IoClose, IoTrash } from "react-icons/io5";
import { useReportBespoke } from "@iliotech/data-wire";
import { useClickAway } from "react-use";
export const ReportPageSelect: React.FC<{ pageId: string }> = ({ pageId }) => {
  const [isOpen, setIsOpen] = useState(false);

  const store = useReportBespoke();

  const onDelete = () => {
    store.removePage(pageId);
  };

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const handleClose = () => {
    setIsOpen(false);
  };
  const anchor = useRef(null);

  useClickAway(anchor, (e) => {
    if (isOpen) {
      setIsOpen(false);
    }
  });

  return (
    <div
      ref={anchor}
      style={{
        position: "relative",
        display: "flex",
        gap: "1rem",
      }}
    >
      <div onClick={handleClick} className={styles.button}>
        <LayoutIcon />
        Change Layout
      </div>
      <div onClick={onDelete} className={styles.button}>
        <IoTrash size={20} />
        Remove Page
      </div>
      {isOpen && <ReportLayoutDropdown onClose={handleClose} pageId={pageId} />}
    </div>
  );
};
